import axios from 'axios';
import {confirmAlert} from 'react-confirm-alert';
import {apiUrl} from './apiAmbiente';
import {CHAVE_SESSAO,usuarioDaSessao} from './sessaoUsuario';
import {solicitarAutorizacaoCC} from './AutorizarExcedenteCC';

const pendentes=new Map();

export async function requisitarCaixaSeguro(endpoint,dados) {
  const token=sessionStorage.getItem(CHAVE_SESSAO)||'';
  if(!token)throw new Error('Sua sessão precisa ser renovada. Saia e entre novamente.');
  const usuario=usuarioDaSessao();
  const campos=Array.from(dados.entries())
    .filter(([k])=>!['token','apikey','user','chave_idempotencia','cc_desafio','cc_login','cc_senha'].includes(k))
    .sort(([a],[b])=>a.localeCompare(b));
  const origem=JSON.stringify([endpoint,usuario?.id,usuario?.suporte?.sessao||'',campos]);
  const bytes=await window.crypto.subtle.digest('SHA-256',new TextEncoder().encode(origem));
  const hash=Array.from(new Uint8Array(bytes),b=>b.toString(16).padStart(2,'0')).join('');
  const armazenamento='MB_CAIXA_PENDENTE:'+hash;
  let chave=pendentes.get(armazenamento);
  try {chave=chave||sessionStorage.getItem(armazenamento);} catch (_) { /* Mantem a chave em memoria. */ }
  if(!chave){
    chave=Array.from(window.crypto.getRandomValues(new Uint8Array(24)),b=>b.toString(16).padStart(2,'0')).join('');
    pendentes.set(armazenamento,chave);
    try {sessionStorage.setItem(armazenamento,chave);} catch (_) { /* A transacao continua protegida no servidor. */ }
  }
  async function enviar(autorizacao){
    const envio=new FormData();for(const [k,v] of dados.entries())if(!['cc_desafio','cc_login','cc_senha'].includes(k))envio.append(k,v);
    envio.set('token',token);envio.set('chave_idempotencia',chave);
    if(autorizacao)Object.entries(autorizacao).forEach(([k,v])=>envio.set(k,v));
    let resposta;
    try{resposta=await axios.post(apiUrl(endpoint),envio);}
    catch(e){if(!e.response)e.message='Não foi possível confirmar a gravação. Confira os movimentos antes de repetir. Uma nova tentativa com os mesmos dados usará o mesmo identificador. '+(e.message||'');throw e;}
    finally{envio.delete('cc_senha');envio.delete('cc_login');envio.delete('cc_desafio');}
    if(resposta.data?.ok!==true)throw new Error(resposta.data?.erro||'O servidor não confirmou a operação. Confira os movimentos antes de tentar novamente.');
    return resposta;
  }
  try {
    let resposta;
    try{resposta=await enviar();}
    catch(e){const data=e.response?.data;if(data?.codigo!=='CC_LIMITE_EXCEDIDO'||!data.autorizacao_cc)throw e;resposta=await solicitarAutorizacaoCC(data.autorizacao_cc,enviar);}
    pendentes.delete(armazenamento);
    try {sessionStorage.removeItem(armazenamento);} catch (_) { /* Sem efeito financeiro. */ }
    return resposta;
  }catch(e){
    if(e.cancelado)throw e;
    const mensagem=e.response?.data?.erro||e.message||'Não foi possível concluir a operação.';
    throw new Error(mensagem);
  }
}

export function exibirErroCaixa(erro) {
  const botao=document.getElementById('btnGravarPG');
  if(botao)botao.style.display='';
  if(erro.cancelado)return;
  confirmAlert({title:'Operação não concluída',message:erro.message||'Confira o caixa e tente novamente.',buttons:[{label:'Entendi',onClick:()=>{}}],closeOnClickOutside:false});
}
